export const ENABLE_NEW_INSTANT_CHECKOUT = 'ENABLE_NEW_INSTANT_CHECKOUT';
